import axios from 'axios'
import Cookie from 'js-cookie'
import {
    AUTHORIZATION_COOKE,
    COOKIE_DOMAIN,
    GOOGLE_AUTH_ROUTE,
    LEGACY_SHARING_ROUTES,
    PRIVACY_POLICY_ROUTE,
    TERMS_OF_SERVICE_ROUTE,
} from '../constants'
import { applyWalkthroughAdapter } from '../dev/walkthroughApi'
import getEnvVars from '../environment'
import { clearDailyHomeDestination } from './dailyHome'
import { isReadOnlyError, markReadOnlyWriteRejected } from './readOnly'

const { REACT_APP_FRONTEND_BASE_URL, REACT_APP_API_BASE_URL } = getEnvVars()

// slightly hacky way of checking if a page should be accessible if the user is not logged in
export const isPublicPage = () => {
    const publicRoutes = [TERMS_OF_SERVICE_ROUTE, PRIVACY_POLICY_ROUTE, GOOGLE_AUTH_ROUTE, ...LEGACY_SHARING_ROUTES]
    return publicRoutes.includes(window.location.pathname.split('/')[1]) // removes leading slash from url
}

const apiClient = axios.create({
    baseURL: REACT_APP_API_BASE_URL,
})

apiClient.interceptors.request.use(
    (config) => {
        config.headers = {
            Authorization: `Bearer ${Cookie.get(AUTHORIZATION_COOKE)}`,
            'Access-Control-Allow-Origin': REACT_APP_FRONTEND_BASE_URL,
            'Access-Control-Allow-Headers':
                'Authorization,Access-Control-Allow-Origin,Access-Control-Allow-Headers,Access-Control-Allow-Methods,Timezone-Offset',
            'Access-Control-Allow-Methods': 'POST,OPTIONS,GET,PATCH,DELETE',
            'Timezone-Offset': new Date().getTimezoneOffset().toString(),
        }
        return applyWalkthroughAdapter(config)
    },
    (error) => Promise.reject(error)
)

apiClient.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        // The server owns the recovery-path allowlist; react to its authoritative rejection instead
        // of maintaining a second client-side route list that can drift and block account recovery.
        if (isReadOnlyError(error)) {
            markReadOnlyWriteRejected()
        }
        if (error.response?.status === 401 && !isPublicPage()) {
            clearDailyHomeDestination()
            axios.defaults.headers.common['Authorization'] = ''
            Cookie.remove(AUTHORIZATION_COOKE, { path: '/', domain: COOKIE_DOMAIN })
            Cookie.remove(AUTHORIZATION_COOKE) // used for cypress tests
            window.location.replace(REACT_APP_FRONTEND_BASE_URL)
        }
        return Promise.reject(error)
    }
)

export default apiClient
